import React, { useState } from "react";
import AdminCateEditModal from "./AdminCateEditModal";
import ActiveFormModal from "./ActiveFormModal";
import defaultimg from "../assets/img/dummy.jpeg";
import { getAllCategories, updateCategoriesById } from "../actions/categories";
import { useDispatch } from "react-redux";

const AdminCateListRow = ({ current, i }) => {
  const [showEditCategoryModal, setshowEditCategoryModal] = useState(false);
  const openEditCategoryModal = () => {
    setshowEditCategoryModal((showEditCategoryModal) => !showEditCategoryModal);
  };
  const [showActiveModal, setshowActiveModal] = useState(false);
  const openActiveModal = () => {
    setshowActiveModal((showActiveModal) => !showActiveModal);
  };
  const dispatch = useDispatch();
  // const [values, setValues] = useState({
  //   _id: "",
  //   status: "",
  // });
  const handleSubmit = async (event) => {
    event.preventDefault();
    const updatedStatus = !current.status; // Toggle the boolean value
    const statusData = {
      _id: current.id,
      status: updatedStatus, // Assign the toggled value
    };
    dispatch(updateCategoriesById(statusData));

    setTimeout(() => {
      dispatch(getAllCategories());
    }, 1000);
    setshowActiveModal(false);
  };
  return (
    <>
      <tr>
        <td>{i + 1}</td>
        <td>
          <img
            src={
              current?.profilePic?.fileUrl
                ? current?.profilePic?.fileUrl
                : defaultimg
            }
            alt="Category Image"
            // style={{ width: "40", height: "40" }}
            className="default-pic-height rounded border"
          />
        </td>
        <td>{current.name}</td>
        <td>
          {current.status === true ? (
            <a
              href="#"
              className="btn btn-sm btn-success"
              onClick={openActiveModal}
            >
              Active
            </a>
          ) : (
            <a
              href="#"
              className="btn btn-sm btn-dark"
              onClick={openActiveModal}
            >
              Deactivated
            </a>
          )}
          <a
            href="#"
            className="btn btn-sm btn-primary mx-1"
            onClick={openEditCategoryModal}
          >
            Edit
          </a>
          <a href="#" className="btn btn-sm btn-danger">
            Delete
          </a>
        </td>
      </tr>
      <ActiveFormModal
        openActiveModal={openActiveModal}
        showActiveModal={showActiveModal}
        current={current}
        handleSubmit={handleSubmit}
      />
      <AdminCateEditModal
        openEditCategoryModal={openEditCategoryModal}
        showEditCategoryModal={showEditCategoryModal}
        current={current}
      />
    </>
  );
};

export default AdminCateListRow;
